import { createGlobalStyle, css } from 'styled-components';
const DefaultHelperClass = createGlobalStyle `${css `
	.uppercase {
		text-transform: uppercase;
	}

	.lowercase {
		text-transform: lowercase;
	}

	.capitalize {
		text-transform: capitalize;
	}

	.underline {
		text-decoration: underline;
	}

	.line-through {
		text-decoration-line: line-through;
	}

	.hidden-container {
		overflow: hidden;
	}

	.nowrap {
		white-space: nowrap;
	}

	.align-right {
		text-align: right;
	}

	.align-center {
		text-align: center;
	}

	.opacity-zero {
		opacity: 0;
	}

	.cursor-pointer {
		cursor: pointer;
	}

	.display-none {
		display: none;
	}

	.pointer-none {
		pointer-events: none;
	}

	.user-select-none {
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
	}

	.ellipsis {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.first-letter {
		&::first-letter {
			text-transform: capitalize;
		}
	}
`}`;
export default DefaultHelperClass;
//# sourceMappingURL=helperClass.js.map